// extracted by mini-css-extract-plugin
export default {"title":"i_TAlFvZzIx7RaFpq5DG","message":"BP8oQrawE80hccRHRq07"};